import { render, staticRenderFns } from "./ChatterSnippetList.vue?vue&type=template&id=2e9d9632"
import script from "./ChatterSnippetList.vue?vue&type=script&lang=js"
export * from "./ChatterSnippetList.vue?vue&type=script&lang=js"
import style0 from "./ChatterSnippetList.vue?vue&type=style&index=0&id=2e9d9632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports